import React from "react";
import { Form } from "react-bootstrap";
import InfoIcon from "./InfoIcon";
import RequiredIcon from "./RequiredIcon";

interface IProps {
    controlId: string;
    id?: string;
    label?: string;
    hoverTitle?: string;
    className?: string;
    name: string;
    value: boolean;
    required: boolean;
    infoCode?: string;
    onFocusHandler?: (name: string, value: any) => void;
    onChangeHandler?: (name: string, value: any) => void;
    onBlurHandler?: (name: string, value: any) => void;
    isInvalid: boolean;
    error?: string;
    disabled?: boolean;
}

class BaseCheckbox extends React.Component<IProps> {
    private onFocusHandler = (evt: React.FocusEvent<HTMLInputElement>) => {
        let value = evt.currentTarget.checked;
        if (this.props.onFocusHandler != null) {
            this.props.onFocusHandler(this.props.name, value);
        }
    };

    private onChangeHandler = (evt: React.ChangeEvent<HTMLInputElement>) => {
        let value = evt.currentTarget.checked;
        if (this.props.onChangeHandler != null) {
            this.props.onChangeHandler(this.props.name, value);
        }
    };

    private onBlurHandler = (evt: React.FocusEvent<HTMLInputElement>) => {
        let value = evt.currentTarget.checked;

        if (this.props.onBlurHandler != null) {
            this.props.onBlurHandler(this.props.name, value);
        }
    };

    public render(): JSX.Element {
        const {
            controlId,
            id,
            label,
            hoverTitle,
            className,
            name,
            value,
            required,
            infoCode,
            isInvalid,
            error,
            disabled,
        } = this.props;

        return (
            <Form.Group className="mb-0 mt-1" controlId={controlId}>
                <Form.Check
                    id={id}
                    className={className}
                    name={name}
                    label={
                        label ? (
                            <>
                                {label} {required ? <RequiredIcon /> : null}
                                {infoCode ? <InfoIcon label={label} code={infoCode} /> : null}
                            </>
                        ) : undefined
                    }
                    title={hoverTitle}
                    type="checkbox"
                    onFocus={this.onFocusHandler}
                    onChange={this.onChangeHandler}
                    onBlur={this.onBlurHandler}
                    checked={value}
                    isInvalid={isInvalid}
                    autoComplete="off"
                    disabled={disabled}
                    custom
                />
                <Form.Control.Feedback type="invalid" className="d-block bg-transparent mt-1">
                    {error}
                </Form.Control.Feedback>
            </Form.Group>
        );
    }
}

export { BaseCheckbox as Unconnected };
export default BaseCheckbox;
